import { render } from "./jumlah-member.vue?vue&type=template&id=4a36d4cd&scoped=true"
import script from "./jumlah-member.vue?vue&type=script&lang=js"
export * from "./jumlah-member.vue?vue&type=script&lang=js"

import "./jumlah-member.vue?vue&type=style&index=0&id=4a36d4cd&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a36d4cd"]])

export default __exports__